import Vue from 'vue'

export interface frModel {
  is: boolean
}

export class ForceRender {
  constructor(vue: Vue) {
    this.context = vue
  }

  private _frObj: frModel = { is: true }
  private context: Vue

  get if() {
    return this._frObj.is
  }

  execute() {
    this._frObj.is = false
    this.context.$nextTick(() => {
      this._frObj.is = true
    })
  }
}